module.exports = __webpack_public_path__ + "assets/7fef298f79b77e5ed1ba9a5c67256d19.mp3";